import logger from './rbata.logger';

const page = {
    /**
     * Adds class page-greyout to passed element, if no element passed it will add to the main
     */
    addBackdrop(add = true, $element = $('.page-main')) {
        if ($element instanceof jQuery) {
            add ? $element.addClass('page--greyout') : $element.removeClass('page--greyout');
        } else {
            logger.log(`${$element} is not a jQuery object. addBackdrop method require jQuery object for $element`)
        }
    }
}

export default page;